import { useLocation } from 'react-router-dom';
import { broadcastRoutes } from 'router/broadcastRoutes';
import { recognitionRoutes } from 'router/recognitionRoutes';
import { taskRoutes } from 'router/taskRoutes';

type BroadcastRoutesType = typeof broadcastRoutes;
type TaskRoutesType = typeof taskRoutes;
type RecognitionRoutesType = typeof recognitionRoutes;
type RoutesType = BroadcastRoutesType | TaskRoutesType | RecognitionRoutesType;

export const useAppLocation = (routes: RoutesType) => {
  const location = useLocation();

  return {
    isCreate: location.pathname === routes.create,
    isNotFound: location.pathname === routes.notFound,
  };
};
